import { motion } from "framer-motion";
import { Heart, Flower2 } from "lucide-react";

const seeds = Array.from({ length: 22 }).map((_, i) => ({
  id: i,
  left: (i * 47) % 100,
  delay: (i % 10) * 0.4,
  duration: 9 + ((i * 3) % 8),
  size: 14 + (i % 4) * 5,
  type: i % 3 === 0 ? "flower" : i % 3 === 1 ? "heart" : "petal",
  drift: ((i % 5) - 2) * 30,
  hue: i % 2 === 0 ? "#D71920" : "#D4AF37",
}));

export default function FloatingElements() {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" data-testid="floating-elements">
      {seeds.map((s) => (
        <motion.div
          key={s.id}
          className="absolute"
          style={{
            left: `${s.left}%`,
            bottom: -40,
            color: s.hue,
          }}
          initial={{ y: 0, opacity: 0, rotate: 0, x: 0 }}
          animate={{
            y: -window.innerHeight - 60,
            x: [0, s.drift, -s.drift, 0],
            opacity: [0, 0.9, 0.9, 0],
            rotate: [0, 30, -20, 40],
          }}
          transition={{
            duration: s.duration,
            repeat: Infinity,
            delay: s.delay,
            ease: "easeInOut",
          }}
        >
          {s.type === "flower" && (
            <Flower2
              style={{ width: s.size, height: s.size }}
              strokeWidth={1.5}
              fill={s.hue === "#D71920" ? "#D71920" : "none"}
            />
          )}
          {s.type === "heart" && (
            <Heart
              style={{ width: s.size, height: s.size }}
              strokeWidth={1.5}
              fill="#D71920"
              color="#D71920"
            />
          )}
          {s.type === "petal" && (
            <div
              style={{
                width: s.size * 0.7,
                height: s.size,
                background:
                  "radial-gradient(circle at 30% 30%, #FF6F6F 0%, #D71920 70%, #8a0c12 100%)",
                borderRadius: "50% 0 50% 50%",
                transform: "rotate(45deg)",
                boxShadow: "0 0 6px rgba(215, 25, 32, 0.5)",
              }}
            />
          )}
        </motion.div>
      ))}
    </div>
  );
}
